import axios from '@/axios.js';

export const faqApi = {
  getFaqs(payload) {
    return axios.get('admin/faqs', {
      params: payload,
    });
  },
  getFaq(id) {
    return axios.get(`admin/faqs/${id}?join=translations`);
  },
  addFaq(body) {
    return axios.post('admin/faqs', body);
  },
  updateFaq(id, body) {
    return axios.patch(`admin/faqs/${id}`, body);
  },
  deleteFaq(id) {
    return axios.delete(`admin/faqs/${id}`);
  },
};
